export default __webpack_public_path__ + "static/media/gif1.fcb96ebe.gif";